import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid} from '@mui/material';

import {EmpionMultiSelect} from '../../../../../../components/EmpionMultiSelect/EmpionMultiSelect';
import {LanguageContext} from '../../../../../../contexts/LanguageContext/LanguageContext';
import {handleCompanyDepartmentsOptions} from '../../../../../../utils/companyDepartmentsUtils/companyDepartmentsUtils';
import {handleCompanyLocationsOptions} from '../../../../../../utils/companyLocationsUtils/companyLocationsUtils';
import {CompanyDepartmentsResponse, CompanyProfile} from '../../../../profile/types';

interface JobPostingsFilterProps {
  companyLocations: CompanyProfile['locations'];
  companyDepartments: CompanyDepartmentsResponse['companyDepartments'];
  handleFilteredJobPostings: (event: any) => void;
}

export default function JobPostingsFilter({
  companyLocations,
  handleFilteredJobPostings,
  companyDepartments,
}: JobPostingsFilterProps) {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  const multiSelectStyles = {
    height: '46px',
    borderRadius: '8px',
    padding: '8px, 16px, 8px, 16px',
    gap: '8px',
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginBottom: {
          xs: '24px',
        },
        display: 'flex',
        justifyContent: 'flex-start',
      }}
    >
      <Grid item>
        <EmpionMultiSelect
          label={t('companyJobPostings.jobPostingsFilter.department')}
          options={handleCompanyDepartmentsOptions(companyDepartments, currentLanguage)}
          onChange={handleFilteredJobPostings}
          sx={[{width: '178px'}, multiSelectStyles]}
          filteringFor={'department'}
          backgroundVariant='dark'
        />
      </Grid>
      <Grid item>
        <EmpionMultiSelect
          label={t('companyJobPostings.jobPostingsFilter.location')}
          options={handleCompanyLocationsOptions(companyLocations)}
          onChange={handleFilteredJobPostings}
          sx={[{width: '146px'}, multiSelectStyles]}
          filteringFor={'location'}
          backgroundVariant='dark'
        />
      </Grid>
    </Grid>
  );
}
